// src/lib/supabaseClient.js
// G2 Phase C3 — browser Supabase client.
//
// Uses the publishable/anon key, which is safe to ship in the browser because
// Row Level Security governs every request. Never put the secret/service key here.
//
// REACT_APP_* vars are inlined by CRA at BUILD time, so both must exist in Vercel
// before the deploy that ships this file.

import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Clear message instead of a cryptic createClient crash.
  console.error(
    '[supabaseClient] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. ' +
    'Set both in Vercel (inlined at build time) and redeploy.'
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // MUST be true for OAuth. Google and Microsoft complete sign-in by
    // redirecting back with the session in the URL fragment
    // (#access_token=…&refresh_token=…). With this false the client never
    // reads that fragment, so the token sits in the address bar and no session
    // is ever created — the user is bounced back to the login page holding a
    // perfectly valid token.
    //
    // It was false from the original build (45a53e3), which was harmless then:
    // email/password sign-in returns its session in the response body and never
    // uses a fragment. It became a bug the moment the SSO buttons shipped
    // (B33), and was found on the first real Google sign-in, 1 Sep 2026.
    //
    // The client also strips the fragment from the URL after reading it, so the
    // token does not linger in history or get copied into a bug report.
    detectSessionInUrl: true,
    storageKey: 'digitalme_auth',
  },
});
